import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { withTranslation, TFunction } from 'react-i18next';
import { connect } from 'react-redux';

// Redux Actions - Match Reference
import ApplyWithdrawalActions from '../../../redux/ApplyWithdrawalRedux';
import GetFileDownloadActions from '../../../redux/GetFileDownloadRedux';
import DeleteWithdrawalActions from '../../../redux/DeleteWithdrawalRedux';
import CreateWithdrawalActions from '../../../redux/CreateWithdrawalRedux';

// Components
import UploadFileComponent from '../../../components/UploadFileComponent';

import './WithdrawalPage.css';

interface WithdrawalPageProps {
  navigate?: NavigateFunction;
  t?: TFunction;
  
  // Redux Props - Match Reference
  status?: any;
  applyWithdrawalFetching?: boolean;
  applyWithdrawalSuccess?: boolean;
  applyWithdrawalError?: boolean;
  applyWithdrawalStatus?: number;
  listFileDownload?: any;
  listFileWithdrawal?: any;
  
  // Redux Actions - Match Reference
  applyWithdrawal?: (withdrawal_id: string) => void;
  getFileDownload?: () => void;
  deleteWithdrawal?: (withdrawal_id: string) => void;
  clearWithdrawalData?: () => void;
  
  // Navigation params (would come from route params in React)
  withdrawal_id?: string;
  leave_id?: string;
  children_id?: string;
}

interface WithdrawalPageState {
  // Track uploaded files count for validation
  uploadedFilesCount: number;
}

class WithdrawalPage extends Component<WithdrawalPageProps, WithdrawalPageState> {
  constructor(props: WithdrawalPageProps) {
    super(props);
    console.log('WithdrawalPage: Constructor called with props:', props);
    console.log('WithdrawalPage: withdrawal_id:', props.withdrawal_id);
    console.log('WithdrawalPage: leave_id:', props.leave_id);
    console.log('WithdrawalPage: children_id:', props.children_id);
    
    // Call getFileDownload on construction - match reference
    if (this.props.getFileDownload) {
      this.props.getFileDownload();
    }
    this.state = {
      uploadedFilesCount: 0,
    };
  }

  componentDidMount() {
    console.log('WithdrawalPage: componentDidMount called');
    console.log('WithdrawalPage: Current props in componentDidMount:', {
      withdrawal_id: this.props.withdrawal_id,
      leave_id: this.props.leave_id,
      children_id: this.props.children_id,
      listFileWithdrawal: this.props.listFileWithdrawal
    });
    
    // Initialize uploaded files count based on server data
    if (this.props.listFileWithdrawal?.data?.length > 0) {
      this.setState({ uploadedFilesCount: this.props.listFileWithdrawal.data.length });
    }
  }

  // Match reference componentDidUpdate exactly
  async componentDidUpdate(prevProps: WithdrawalPageProps) {
    // Update file count if server data changes
    if (prevProps.listFileWithdrawal?.data?.length !== this.props.listFileWithdrawal?.data?.length) {
      const serverFileCount = this.props.listFileWithdrawal?.data?.length || 0;
      if (serverFileCount > this.state.uploadedFilesCount) {
        this.setState({ uploadedFilesCount: serverFileCount });
      }
    }
    if (!this.props.applyWithdrawalFetching) {
      if (
        this.props.applyWithdrawalSuccess &&
        this.props.applyWithdrawalSuccess !== prevProps.applyWithdrawalSuccess
      ) {
        if (this.props.status?.success === false) {
          alert(this.props.status?.message || 'Error occurred');
        } else {
          const successMessage = this.props.t ? 
            this.props.t('select-leavere-quest:withdrawal-submited') : 
            'Withdrawal submitted successfully';
          alert(successMessage);
          
          // Clear withdrawal data before navigation
          if (this.props.clearWithdrawalData) {
            console.log('WithdrawalPage: Clearing withdrawal data after successful submission');
            this.props.clearWithdrawalData();
          }
          
          // Navigate back after success
          if (this.props.navigate) {
            this.props.navigate(-1);
          }
        }
      }

      if (
        this.props.applyWithdrawalError &&
        this.props.applyWithdrawalError !== prevProps.applyWithdrawalError
      ) {
        const errorMessage = this.props.t ? 
          this.props.t('select-leavere-quest:message-error') : 
          'An error occurred';
        alert(errorMessage);
      }
    }
  }

  // Match reference navigation - back deletes withdrawal
  back = () => {
    if (this.props.deleteWithdrawal && this.props.withdrawal_id) {
      this.props.deleteWithdrawal(this.props.withdrawal_id);
    }
    if (this.props.navigate) {
      this.props.navigate(-1);
    }
  };

  // Download file method - match reference
  async _onDownloadItemPress(url?: string) {
    if (url) {
      // Detect iOS device
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      // Try to download the file
      try {
        if (isIOS) {
          // Open in the same tab for iOS Safari
          window.location.href = url;
        } else {
          window.open(url, '_blank');
        }
      } catch (error) {
        console.error('Error opening download URL:', error);
        alert('Error opening download link. Please try again.');
      }
    } else {
      // If no URL, try to get fresh data and check again
      if (this.props.getFileDownload) {
        this.props.getFileDownload();
        alert('Download data not available. Refreshing data, please try again in a moment.');
      } else {
        alert('Download functionality not available.');
      }
    }
  }

  // Check file method - match reference
  checkFile = () => {
    const message = this.props.t ? 
      this.props.t('withdrawal:please-upload-withdrawal-form') : 
      'Please upload withdrawal form';
    alert(message);
  };

  // Check if files are available (server or local)
  hasUploadedFiles = () => {
    // Check server files first
    if (this.props.listFileWithdrawal?.data?.length > 0) {
      return true;
    }
    
    // Check local uploaded files count
    if (this.state.uploadedFilesCount > 0) {
      return true;
    }
    
    return false;
  };

  // Apply withdrawal method - match reference
  applyLeavee = () => {
    if (this.props.applyWithdrawal && this.props.withdrawal_id) {
      this.props.applyWithdrawal(this.props.withdrawal_id);
    }
  };

  // Match reference render method exactly
  render() {
    return (
      <div className="withdrawal-page">
        <div>
          {/* Header */}
          <div className="page-header">
            <div className="page-header-inner">
              <div className="header-left">
                <button className="header-button back-button" onClick={this.back}>
                  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z" fill="black"></path></svg>
                </button>
                <h1 className="header-title">
                    {this.props.t ? this.props.t('withdrawal:withdrawal') : 'Submit withdrawal form'}
                  </h1>
              </div>
            </div>
          </div>
          <div className="withdrawal-content">
            <div className="withdrawal-steps">
              {/* Step 1: Download */}
              <p>
                {this.props.t ? this.props.t('withdrawal:text-download') : 'Step 1: Download following document and fill in information to submit withdrawal request'}
              </p>
            </div>
            <div className="withdrawal-btns">
              <button
                onClick={() => {
                  // Try multiple possible data structures
                  const downloadData = this.props.listFileDownload;
                  let url = null;
                  
                  if (downloadData?.data?.[0]?.url) {
                    url = downloadData.data[0].url;
                  } else if (downloadData?.url) {
                    url = downloadData.url;
                  } else if (downloadData?.[0]?.url) {
                    url = downloadData[0].url;
                  } else if (typeof downloadData === 'string') {
                    url = downloadData;
                  }
                  
                  this._onDownloadItemPress(url);
                }}
              >
                <span>
                  {this.props.t ? this.props.t('withdrawal:download-file') : 'Download'}
                </span>
              </button>
              <p>
                {this.props.t ? this.props.t('withdrawal:button-download') : '(TAP ON BUTTON DOWNLOAD TO SAVE THE FORM TO YOUR DEVICE)'}
              </p>
            </div>
            <div className="withdrawal-steps">
              {/* Step 2: Upload */}
              <p>
                {this.props.t ? this.props.t('withdrawal:text-upload') : 'Step 2: Upload the form with information filled'}
              </p>
            </div>
            <div className="withdrawal-btns">
                {/* UploadFileComponent - Match Reference */}
                {this.props.withdrawal_id && this.props.withdrawal_id !== 'withdrawal_form' ? (
                  <UploadFileComponent
                    leave_id={this.props.leave_id}
                    children_id={this.props.children_id}
                    withdrawal_id={this.props.withdrawal_id}
                    isSickImage={false}
                    onFileUpload={(count: number) => this.setState({ uploadedFilesCount: count })}
                  />
                ) : (
                  <div>
                    <p>
                      {this.props.t ? 
                        this.props.t('withdrawal:no-withdrawal-id') || 'No withdrawal ID available' : 
                        'No withdrawal ID available. Please create a withdrawal first.'
                      }
                    </p>
                    <button
                      onClick={() => this.props.navigate?.(-1)}
                    >
                      {this.props.t ? 
                        this.props.t('withdrawal:go-back') || 'Go Back' : 
                        'Go Back'
                      }
                    </button>
                  </div>
                )}
            </div>
            {/* Bottom Submit Button */}
            <button
              className="withdrawal-submit comman-btn w-100"
              onClick={() => {
                if (!this.props.withdrawal_id || this.props.withdrawal_id === 'withdrawal_form') {
                  alert('No withdrawal ID available. Please create a withdrawal first.');
                  return;
                }
                
                this.hasUploadedFiles()
                  ? this.applyLeavee()
                  : this.checkFile();
              }}
            >
              <span>
                {this.props.t ? this.props.t('make-up-session:submit') : 'Submit'}
              </span>
            </button>
          </div>
          


          

          
        </div>
      </div>
    );
  }
}

// Match reference Redux connection exactly
const mapStateToProps = (state: any) => ({
  status: state.applyWithdrawal?.dataWithdrawal,
  applyWithdrawalFetching: state.applyWithdrawal.fetching,
  applyWithdrawalSuccess: state.applyWithdrawal.success,
  applyWithdrawalError: state.applyWithdrawal.error,
  applyWithdrawalStatus: state.applyWithdrawal.status,
  listFileDownload: state.getFileDownload?.fileDownload || state.getFileDownload?.data || state.getFileDownload,
  listFileWithdrawal: state.getWithdrawal?.listFileWithdrawal,
});

const mapDispatchToProps = (dispatch: any) => ({
  applyWithdrawal: (withdrawal_id: string) =>
    dispatch(ApplyWithdrawalActions.applyWithdrawalRequest(withdrawal_id)),
  getFileDownload: () =>
    dispatch(GetFileDownloadActions.getFileDownloadRequest()),
  deleteWithdrawal: (withdrawal_id: string) =>
    dispatch(DeleteWithdrawalActions.deleteWithdrawalRequest(withdrawal_id)),
  clearWithdrawalData: () =>
    dispatch(CreateWithdrawalActions.clearWithdrawalData()),
});

// Match reference export exactly
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WithdrawalPage));